import React, {useState} from 'react'
import {graphql} from 'gatsby'
import PlaySymbol from '../../assets/svg/play.inline.svg'
import './VideoLink.scss'
import EmbedContainer from '../EmbedContainer/EmbedContainer'

export default function VideoLink({text, embed}) {

	const [videoActive, setVideoActive] = useState(false)

	return(
		<div className="VideoLink">
			{
				videoActive &&
				<EmbedContainer embed={embed} close={() => setVideoActive(false)} />
			}
			<div className="button">
				<PlaySymbol role="button" aria-label="Spill av video" onClick={() => setVideoActive(!videoActive)} />
				<button aria-expanded={videoActive} className="Link arrow" onClick={() => setVideoActive(!videoActive)}>
					{text}
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.011 20.951">
						<g>
							<path d="M37.759,23.354l-7.88-7.88,2.6-2.6L42.95,23.354,32.475,33.83l-2.6-2.6Z" transform="translate(-18.94 -12.879)" fillRule="evenodd"/>
							<path d="M12,27H32.191v3.671H12Z" transform="translate(-12 -18.36)" />
						</g>
					</svg>
				</button>
			</div>
		</div>
	)
}

export const query = graphql`
	fragment VideoLink on WpPage_Layout_block_Layout_VideoLink {
		fieldGroupName
		text
		embed
	}
`